module.exports = __webpack_public_path__ + "assets/img/Future_Strip.99cbf64f-ps.jpg";